module.exports = __webpack_public_path__ + "img/programmki-mob.1ca028d2.jpg";